// [GEN-AI-ASSISTED]
window.mcb = window.mcb || {};
window.mcb.tracking = (function () {
  // Private variables
  const _logger = window.mcb.utilities.createLogger('tracking', 'Tracking System');
  const _adobeActiveInDomain = window.adobeActiveInDomain || false;
  const _readynessInterval = 250;
  const _messageQueue = [];
  let _readynessTimer;

  // Consent is decided server-side at page load: the Adobe Launch script is
  // either emitted as text/javascript (allowed) or text/plain + optanon-category
  // (blocked, only activated by OneTrust if the user has opted in). When the
  // user changes their consent, OneTrust reloads the page (see onetrust.js),
  // so we never need to track consent state at runtime here.

  const flushQueue = function () {
    _logger.trace('dbg: flushing');
    if (_readynessTimer) {
      clearInterval(_readynessTimer);
      _readynessTimer = undefined;
    }

    if (_messageQueue.length > 0) {
      _logger.trace("Performing delayed tracking of " + _messageQueue.length + " messages");

      while (_messageQueue.length > 0) {
        let pair = _messageQueue.pop();
        _logger.trace('dbg: delayed tracking of ' + pair.ruleName);
        performTrackingEvent(pair.ruleName, pair.obj);
      }
    }
  };

  const performTrackingEvent = function (ruleName, obj) {
    if (ruleName.indexOf('Callable') !== 0) {
      ruleName = "Callable" + ruleName;
    }

    for (let prop in obj) {
      obj[prop] = window.mcb.utilities.browser.parseHtml(obj[prop]);
    }

    _satellite.track(ruleName, obj);
  }

  // Internal functions
  const track = function (ruleName, obj) {
    _logger.trace('dbg: entered window.mcb.tracking.track');

    if (!_adobeActiveInDomain) {
      _logger.warn('Tracking is not active - registration is not possible');
    }
    else if (typeof _satellite === "object" && typeof _satellite.track === "function") {
      _logger.trace('dbg: track as normal');
      flushQueue();
      performTrackingEvent(ruleName, obj);
    }
    else {
      _logger.trace('dbg: queuing message');
      _messageQueue.push({
        ruleName,
        obj
      });

      if (!_readynessTimer) {
        _readynessTimer = setInterval(function () {
          _logger.trace('dbg: interval');
          if (typeof _satellite === "object" && typeof _satellite.track === "function") {
            flushQueue();
          }
        }, _readynessInterval);
      }
    }
  };

  // Public interface
  return {
    track
  };
})();
